/**
 * Plugin to add tracker functionnalities.
 */
import { LuxService } from '~/services/trackers/lux';
import { GtmService } from '~/services/trackers/gtm';
export default defineNuxtPlugin(function () {
  return {
    provide: {
      trackers: {
        lux: new LuxService(),
        gtm: new GtmService()
      }
    }
  };
});